/**
 *
 */
export class ScrollItemVO {
    private _id: number;
    private _active: boolean = false;

    public get id(): number {
        return this._id;
    }

    public get active(): boolean {
        return this._active;
    }

    public set active(value: boolean) {
        this._active = value;
    }

    public set id(value: number) {
        this._id = value;
    }
}
